function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  points: "8.355,25.748 35.037,6.351 61.719,25.748 70.074,25.748 35.037,0.278 0,25.748  ",
  fill: "#050358"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#abb8c3"
}, /*#__PURE__*/React.createElement("rect", {
  x: 8.846,
  y: 56.124,
  width: 52.383,
  height: 5.333
}), /*#__PURE__*/React.createElement("rect", {
  x: 1.362,
  y: 64.463,
  width: 67.353,
  height: 5.333
})), /*#__PURE__*/React.createElement("g", {
  fill: "#4292ff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.642,37.921c-0.563-0.397-1.51-0.78-2.833-1.141v8.369c1.816-0.084,3.066-0.746,3.754-1.987 c0.358-0.639,0.541-1.384,0.541-2.212C40.105,39.622,39.617,38.616,38.642,37.921z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.302,27.296c-0.593,0.794-0.89,1.625-0.89,2.497c0,1.049,0.35,1.874,1.049,2.467c0.703,0.598,1.646,1.012,2.835,1.24 v-7.481C32.897,26.075,31.897,26.495,31.302,27.296z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.037,17.762c-10.105,0-18.296,8.193-18.296,18.293c0,10.105,8.191,18.299,18.296,18.299 c10.105,0,18.297-8.193,18.297-18.299C53.334,25.953,45.143,17.762,35.037,17.762z M40.218,46.188 c-1.018,0.649-2.489,1.09-4.407,1.3v3.089h-1.511v-3.089c-3.089-0.196-5.186-1.291-6.288-3.275 c-0.605-1.072-0.907-2.519-0.907-4.348h2.815c0.087,1.455,0.315,2.519,0.691,3.188c0.661,1.2,1.892,1.871,3.688,2.017v-8.673 c-2.303-0.438-4.003-1.161-5.104-2.182c-1.099-1.021-1.647-2.432-1.647-4.232c0-1.609,0.591-3.064,1.776-4.355 c1.182-1.302,2.84-1.958,4.975-1.981v-2.114h1.511v2.088c2.109,0.145,3.734,0.766,4.863,1.867 c1.129,1.098,1.722,2.542,1.774,4.338h-2.785c-0.073-0.807-0.292-1.505-0.65-2.086c-0.668-1.072-1.733-1.633-3.2-1.689v7.75 c2.464,0.69,4.134,1.339,5.014,1.943c1.428,0.997,2.145,2.471,2.145,4.428C42.971,42.989,42.052,44.996,40.218,46.188z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgPortabilityMortgageCredit = function SvgPortabilityMortgageCredit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "70.074px",
    height: "70.074px",
    viewBox: "0 0 70.074 70.074",
    style: {
      enableBackground: "new 0 0 70.074 70.074"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPortabilityMortgageCredit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/portabilityMortgageCredit.9d59cba6.svg";
export { ForwardRef as ReactComponent };